import styles from "./styles.module.css";

function BemCard({ nome, valor, imagem, active, ...props }) {
  const realFormat = {
    minimumFractionDigits: 2,
    style: "currency",
    currency: "BRL",
  };

  return (
    <button
      className={`${
        active ? styles.cardContainerActive : styles.cardContainer
      }`}
      {...props}
    >
      <div className={styles.cardImg}>
        <img src={imagem} alt="bem" />
      </div>
      <div className={styles.cardInfos}>
        <div className={styles.cardName}>{nome}</div>
        <div className={styles.cardValue}>
          {valor.toLocaleString("pt-BR", realFormat)}
        </div>
      </div>
    </button>
  );
}

export default BemCard;
